/**
 * お知らせページ用のスクリプト
 */
if (is_route('announcement.index')) {
    // スクリプト読込
    require('./Base/announcement_base.index');

    // コンテンツ読み込み後
    $(document).on('bss:onload', function () {
        announcement_base_event_set();
        announcement_base_setting_event_set();
    });
}

